export default __webpack_public_path__ + "static/mobile-dabd8edf445e4278e122e2fb7d13cc6a.webp";